module.exports = __webpack_public_path__ + "static/media/modal-image.2f57eb12.png";